"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quantity = void 0;
const utils_1 = require("../../utils");
const json_rpc_base_types_1 = require("./json-rpc-base-types");
// TODO(perf): rewrite this stuff since it isn't really caching anything
class Quantity extends json_rpc_base_types_1.BaseJsonRpcType {
    constructor() {
        super(...arguments);
        this._nullable = false;
    }
    static from(value, nullable = false) {
        if (value instanceof Quantity)
            return value;
        const q = new Quantity(value);
        q._nullable = nullable;
        return q;
    }
    toString() {
        // TODO(perf): memoize this stuff
        if (Buffer.isBuffer(this.value)) {
            let val = this.value.toString("hex").replace(/^(?:0+(.+?))?$/, "$1");
            if (val === "") {
                if (this._nullable) {
                    return null;
                }
                // RPC Quantities must represent `0` as `0x0`
                return "0x0";
            }
            return `0x${val}`;
        }
        else if (this.value == null) {
            return "0x";
        }
        else {
            return super.toString();
        }
    }
    toBuffer() {
        // 0x0, 0x00, 0x000, etc should return BUFFER_EMPTY
        if (Buffer.isBuffer(this.value)) {
            // trim zeros from start
            let best = 0;
            for (best = 0; best < this.value.length; best++) {
                if (this.value[best] !== 0)
                    break;
            }
            if (best > 0) {
                return this.value.slice(best);
            }
            else {
                return this.value;
            }
        }
        else if (typeof this.value === "string") {
            let val = this.value.slice(2).replace(/^(?:0+(.+?))?$/, "$1");
            if (val === "" || val === "0") {
                return utils_1.BUFFER_EMPTY;
            }
        }
        else if (this.value === 0 || this.value === 0n) {
            return utils_1.BUFFER_EMPTY;
        }
        return super.toBuffer();
    }
    toBigInt() {
        const value = this.value;
        // TODO(perf): memoize this stuff
        if (Buffer.isBuffer(value)) {
            const bigInt = (0, utils_1.bufferToBigInt)(value);
            return bigInt == null ? (this._nullable ? null : 0n) : bigInt;
        }
        else {
            return value == null ? (this._nullable ? null : 0n) : BigInt(value);
        }
    }
    toNumber() {
        // TODO(perf): memoize this stuff
        return typeof this.value === "number"
            ? this.value
            : Number(this.toBigInt());
    }
    valueOf() {
        const value = this.value;
        if (value === null) {
            return value;
        }
        else if (value === undefined) {
            return value;
        }
        else {
            return this.toBigInt();
        }
    }
}
exports.Quantity = Quantity;
exports.default = Quantity;
//# sourceMappingURL=json-rpc-quantity.js.map